<template>
  <div class="bg-page" ref="bgPage">
    <Form ref="searchFrom" :model="searchFrom" inline>
      <template v-if="checkDate">
        <FormItem>
          <DatePicker
            type="datetime"
            class="search-select"
            :placeholder="$t('select') + $t('start') + $t('date')"
            :value="searchFrom.startTime"
            @on-change="searchFrom.startTime = $event"
            :options="pickerOptions"
          >
          </DatePicker>
        </FormItem>
        <FormItem>
          <DatePicker
            class="search-select"
            type="datetime"
            :placeholder="$t('select') + $t('end') + $t('date')"
            :value="searchFrom.endTime"
            @on-change="searchFrom.endTime = $event"
            :options="pickerOptions"
          >
          </DatePicker>
        </FormItem>
      </template>
      <slot name="select"></slot>
      <template v-if="!hideKeyword">
        <template v-if="inputType == 1">
          <FormItem>
            <Input
              type="textarea"
              class="search-date"
              v-model="searchFrom.keywords"
              :placeholder="$t('keyword')"
              :autosize="{ minRows: 1, maxRows: 2 }"
            >
            </Input>
          </FormItem>
        </template>
        <template v-else>
          <FormItem>
            <Input
              type="text"
              class="search-date"
              v-model="searchFrom.keywords"
              :placeholder="$t('keyword')"
            >
            </Input>
          </FormItem>
        </template>
        <FormItem>
          <Button type="primary" @click="SearchSubmit" icon="md-search">
            {{ $t("search") }}
          </Button>
        </FormItem>
      </template>
      <template v-else>
        <template v-if="hidePage">
          <FormItem> 当前分析中的数量：{{ resultNume }} </FormItem>
        </template>
      </template>
      <slot name="add"> </slot>
      <slot name="oper"></slot>
      <template v-if="listPage">
        <FormItem>
          <Button
            type="primary"
            icon="md-download"
            :disabled="list.length > 0 ? false : true"
            @click="exportExc"
          >
            {{ $t("export") }}
          </Button>
          <!-- <Dropdown>
            <Button type="primary" :disabled="list.length > 0 ? false : true">
              {{ $t("export") }}
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem @click.native="exportExc('all')">
                <Icon type="md-download"></Icon>
                {{ $t("all") }}
              </DropdownItem>
              <DropdownItem @click.native="exportExc('page')">
                <Icon type="md-download"></Icon>
                {{ $t("page") }}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown> -->
        </FormItem>
      </template>
      <slot name="recharge"></slot>
    </Form>
    <vxe-table
      :loading="loading"
      border
      stripe
      resizable
      show-overflow
      highlight-hover-row
      ref="xTable"
      height="600"
      align="center"
      :data="list"
      :edit-config="{ trigger: 'click', mode: 'cell' }"
      :scroll-y="{ mode: 'wheel' }"
      @checkbox-change="selectAll"
      @checkbox-all="selectAll"
    >
      <vxe-column type="checkbox" width="50" fixed="left"></vxe-column>
      <vxe-column
        field="airway_number"
        :title="$t('order_number')"
        width="190"
        fixed="left"
      >
        <template #default="{ row }">
          <vxe-button
            status="primary"
            size="mini"
            @click="btnClick(row, 'show')"
            style="width:110px"
          >
            {{ row.airway_number }}
          </vxe-button>
          <vxe-button
            status="info"
            @click="copy(row.airway_number)"
            size="mini"
            icon="vxe-icon--zoomout"
          >
          </vxe-button>
        </template>
      </vxe-column>

      <vxe-column
        v-for="config in tableTitle"
        :key="config.key"
        :type="config.type"
        :field="config.key"
        :title="config.title"
        :fixed="config.fixed"
        :width="config.minWidth"
        :filters="config.filters"
      >
      </vxe-column>
      <template v-if="orderText == 'customerInt'">
        <vxe-column
          field="operation"
          :title="$t('operation')"
          width="180"
          fixed="right"
        >
          <template #default="{ row }">
            <vxe-button
              status="primary"
              size="mini"
              @click="btnClick(row, '1')"
            >
              轨迹
            </vxe-button>

            <vxe-button
              status="warning"
              size="mini"
              @click="btnClick(row, 'planReturn')"
            >
              {{ $t("planReturn") }}
            </vxe-button>
          </template>
        </vxe-column>
      </template>
      <template v-else>
        <vxe-column
          field="operation"
          :title="$t('operation')"
          width="90"
          fixed="right"
        >
          <template #default="{ row }">
            <vxe-button
              status="primary"
              size="mini"
              @click="btnClick(row, '1')"
            >
              轨迹
            </vxe-button>
          </template>
        </vxe-column>
      </template>
    </vxe-table>
    <template v-if="hidePage">
      <template v-if="billText">
        <div class="flex-content">
          <Page
            ref="pageSize"
            :page-size-opts="arrPageSize"
            :total="total"
            show-sizer
            :page-size="pageSize"
            @on-page-size-change="changeSize"
            @on-change="changePage"
            show-elevator
            show-total
            class-name="page-content"
            :current.sync="pageCurrent"
          />
          <div class="price-content">
            <span class="span-head">合计CNY:</span>
            <span class="span-title">
              {{ totalAmount }}
            </span>
          </div>
        </div>
      </template>
      <template v-else>
        <Page
          ref="pageSize"
          :page-size-opts="arrPageSize"
          :total="total"
          show-sizer
          :page-size="pageSize"
          @on-page-size-change="changeSize"
          @on-change="changePage"
          show-elevator
          show-total
          class-name="page-content"
          :current.sync="pageCurrent"
        />
      </template>
    </template>

    <Modal
      :value="BoolModal"
      class-name="vertical-center-modal"
      closable
      :width="width"
      @on-visible-change="cancel"
      :footer-hide="footerHide"
      :mask-closable="maskClosable"
    >
      <div slot="header" class="custom-header">
        <div class="ivu-modal-header-inner">
          <span>{{ title }}</span>
          <template v-if="pack && title == this.$t('not_arrival_warehouse')">
            <Button
              style="margin-left:20px"
              type="primary"
              @click="copy"
              size="small"
            >
              {{ $t("copy") }}
            </Button>
          </template>
        </div>
      </div>
      <slot name="content"></slot>
      <div slot="footer" class="footer-modal">
        <Button type="primary" @click="confirmModal" :disabled="unChange">
          {{ $t("confirm") }}
        </Button>
        <Button @click="closeModal">{{ $t("cancel") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import paging from "@/utils/page";
import copyClick from "@/utils/copyClick";
import { printSheet } from "@/api/order/list";

export default {
  props: {
    totalAmount: {},
    checkDate: {
      type: Boolean,
      default: false
    },
    billText: {
      type: Boolean,
      default: false
    },
    notList: {
      type: Array
    },
    hidePage: {
      type: Boolean,
      default: true
    },
    currency: {
      type: String
    },
    listPage: {
      type: Boolean
    },
    clientsList: {
      type: Array
    },
    citiesList: {
      type: Array
    },
    maskClosable: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    BoolModal: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number
    },
    unChange: {
      type: Boolean,
      default: false
    },
    footerHide: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number
    },
    total: {
      type: Number
    },
    arrPageSize: {
      type: Array,
      default: () => {
        return [15, 30, 50, 100];
      }
    },
    searchFrom: {
      type: Object
    },
    tableTitle: {
      type: Array
    },
    list: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    roleList: {
      type: Array
    },
    typeList: {
      type: Array
    },
    mappingList: {
      type: Array
    },
    countryList: {
      type: Array
    },
    cityList: {
      type: Array
    },
    agentList: {
      type: Array
    },
    paramsList: {
      type: Array
    },
    clearList: {
      type: Array
    },
    userList: {
      type: Array
    },
    trackerList: {
      type: Array
    },
    labelList: {
      type: Array
    },
    departmentList: {
      type: Array
    },
    bind: {
      type: String
    },
    warehouseList: {
      type: Array
    },
    skuList: {
      type: Array
    },
    goods: {
      type: String
    },
    methodList: {
      type: Array
    },
    freightList: {
      type: Array
    },
    salesmanList: {
      type: Array
    },
    inputType: {
      type: Number,
      default: 0
    },
    parentList: {
      type: Array
    },
    orderText: {
      type: Boolean,
      default: true
    },
    current: {
      type: Number,
      default: 1
    },
    frightPage: {
      type: Boolean
    },
    souqPage: {
      type: Boolean
    },
    showModal: {
      type: Boolean
    },
    pageText: {
      type: Boolean
    },
    orderText: {
      type: String
    },
    hideKeyword: {
      type: Boolean,
      default: false
    },
    resultNume: {
      type: Number
    },
    pack: {
      type: Boolean,
      default: false
    },
    codRefund: {
      type: Boolean,
      default: true
    },
    tableHeight: {
      type: Number,
      default: () => {
        return 650;
      }
    }
  },
  data() {
    return {
      childPage: 0,
      pageCurrent: 1,
      keywords: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  // computed: {
  //   middleKey: function() {
  //     this.pageCurrent = this.current;
  //     return;
  //   }
  //   // prentPage: function () {
  //   //   return this.showModal;
  //   // },
  // },
  // mounted() {
  //   this.$nextTick(() => {
  //     let pageH = this.$refs.bgPage.clientHeight - 40; // 40最大页面的内边距和分页的上外边距
  //     let searchFromH = this.$refs.searchFrom.$el.clientHeight;
  //     if (this.hidePage) {
  //       let pageSizeH = this.$refs.pageSize.$el.clientHeight;
  //       this.tableHeight = pageH - (searchFromH + pageSizeH);
  //       return;
  //     }
  //     this.tableHeight = pageH - searchFromH;
  //   });
  // },
  methods: {
    onExpand(row, status) {
      this.$emit("onExpand", row.id, status);
    },
    // toPath(item) {
    //   this.$router.push({
    //     name: "doubleFeright"
    //   });
    //   this.$store.dispatch("pageUrl", item.airway_number);
    //   this.$store.dispatch("isDouble", true);
    // },
    exportBill() {
      this.$emit("exportBill");
    },
    print(item) {
      this.$emit("print", item.airway_number);
    },
    print1(item, bool) {
      let data = {
        miniLabel: bool,
        single: false,
        orders: [item.airway_number]
      };
      printSheet(data).then(res => {
        if (res.data.status) {
          this.$Message["success"]({
            background: true,
            content: res.data.msg
          });
          window.open(res.data.payload[0], "_blank");
        } else {
          this.$Message["error"]({
            background: true,
            content: res.data.msg,
            duration: 5
          });
        }
      });
    },
    exportExc() {
      this.$emit("exportExc");
    },
    // arrData(arr) {
    //   let selectArr = [];
    //   if (this.pageText) {
    //     arr.some(item => {
    //       selectArr.push(item.airway_bill_number);
    //     });
    //   } else {
    //     arr.some(item => {
    //       selectArr.push(item);
    //     });
    //   }
    //   return selectArr;
    // },
    selectAll(val) {
      console.log(val);
      // let arr = this.arrData(val);
      this.$emit("operClick", val.records);
    },
    closeModal() {
      this.$emit("changeBindModal", false);
    },
    confirmModal() {
      this.$emit("changeBindModal", true);
    },
    cancel(e) {
      this.$emit("closedeleteModal", e);
    },
    changeSize(val) {
      paging.changeSize(val, this);
    },
    changePage(val) {
      paging.changePage(val, this);
    },
    SearchSubmit() {
      paging.SearchSubmit(this);
    },
    btnClick(val, text) {
      this.$emit("crudClick", val, text);
    },
    copy(item) {
      // let data = this.notList.join("\r\n");
      copyClick.copyToClipboard(item, this);
    }
  }
};
</script>

<style lang="less">
.ivu-modal-wrap.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
.delBtn {
  margin: 0 10px;
}
.page-content {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
.bind_role {
  display: flex;
  width: 100%;
  justify-content: center;
  align-content: center;
  background: #000;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  padding: 5px 0;
}
.delBtn.bindBtn {
  margin-left: 0;
}
.ivu-table-cell-tree {
  margin-right: 5px;
}
td.department_name {
  text-align: left;
}
.rateBtn {
  margin: 0 10px;
  margin-left: 0;
}
.ivu-table-body {
  overflow-y: auto;
}
.custom-header {
  display: flex;
  align-items: center;
  justify-content: center;
}
td.operation-td {
  text-align: left;
}
.custom-header .ivu-form-item {
  margin-bottom: 0;
  margin: 0 10px;
}
.custom-header .ivu-modal-header-inner {
  display: flex;
  align-items: center;
}
</style>
